/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { PostUsersAuthRefreshMutationResponse, PostUsersAuthRefresh400 } from "../entities/PostUsersAuthRefresh";

function getPostUsersAuthRefreshUrl() {
  const res = { method: 'POST', url: `/users/auth/refresh` as const }  
  return res
}

/**
 * @description User refresh
 * @summary Refresh
 * {@link /users/auth/refresh}
 */
export async function postUsersAuthRefresh(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<PostUsersAuthRefreshMutationResponse, ResponseErrorConfig<PostUsersAuthRefresh400>, unknown>({ method : "POST", url : getPostUsersAuthRefreshUrl().url.toString(), ... requestConfig })  
  return res.data
}